import { useState } from 'react'
import { PhaserGame as JuicerGame } from './games/juicer/PhaserGame'
import { PhaserGame as CakeGame } from './games/cake/PhaserGame'

const GAMES = [
  { id: 'juicer', label: '🧃 水果榨汁机', Component: JuicerGame },
  { id: 'cake', label: '🎂 做蛋糕', Component: CakeGame },
] as const

type GameId = (typeof GAMES)[number]['id']

export default function App() {
  const [active, setActive] = useState<GameId>('juicer')
  const Active = GAMES.find((g) => g.id === active)!.Component

  return (
    <div className="app">
      <nav className="game-nav">
        {GAMES.map((g) => (
          <button
            key={g.id}
            className={`game-nav-btn${active === g.id ? ' active' : ''}`}
            onClick={() => setActive(g.id)}
          >
            {g.label}
          </button>
        ))}
      </nav>
      <Active key={active} />
    </div>
  )
}
